var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mb-0 px-4 bg-theme-color flex justify-between items-center fixed top-0 z-50",class:_vm.height},[_vm._t("left"),_vm._t("default"),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }